import { RelativeDayLabels } from '@common/audit-trail/auditTrailFormat';
import { AuditTrailSearchRsql } from '@common/audit-trail/buildAuditTrailRsql';
import { t } from 'utils/getTranslations';
import { buildRsqlFromSearchText } from 'utils/searchQueryToRsql';

export function auditTrailDayLabels(): RelativeDayLabels {
    return { today: t('audit-trail.today'), yesterday: t('audit-trail.yesterday') };
}

export function auditTrailRowIdPrefix(): string {
    return t('audit-trail.id');
}

// Record id only, as an exact match (a LIKE would make id 12 surface 112, 120, 3124, …), but
// through the operator-aware search grammar, so `12 OR 13` finds both records.
const SEARCH_SELECTORS = [{ selector: 'rowId', comparator: '==' }];

export const auditTrailSearchRsql: AuditTrailSearchRsql = (search) => buildRsqlFromSearchText(search, SEARCH_SELECTORS);
